import { UpdateActionContext } from 'components/common-form/contexts/UpdateActionContext';
import { useCallback, useContext } from 'react';
import type { UpdateAction } from 'state/formData';

export function useUpdateAction(fieldId: string) {
  const [actionById, setActionType] = useContext(UpdateActionContext);

  const value = actionById[fieldId];
  const setAction = useCallback((val: UpdateAction) => setActionType(fieldId, val), [fieldId, setActionType]);

  return [value, setAction] as const;
}
